import FoodDistributionIndicators from './FoodDistributionIndicators';

export default FoodDistributionIndicators;
